export const IMAGE_SIZE = 4000000;
export const VIDEO_SIZE = 20000000;
